module.exports = __webpack_public_path__ + "static/img/1.34552d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/1.png
// module id = v6AL
// module chunks = 0